import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';


export enum ClaimSecurityRight {
    AccessIncomingClaims = 130000,
    AccessOutgoingClaims = 130001,
    ManageIncomingClaims = 130002,
    ManageOutgoingClaims = 130003,
    ApproveClaimsWithUnresolvedTasks = 130004
}

export class ClaimSecurityModule extends BaseSecurityModule<ClaimSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.Claims,
            [
                { _id: ClaimSecurityRight.AccessIncomingClaims, name: 'Access Incoming Claims', basic: true },
                { _id: ClaimSecurityRight.AccessOutgoingClaims, name: 'Access Outgoing Claims', basic: true },
                { _id: ClaimSecurityRight.ManageIncomingClaims, name: 'Manage Incoming Claims', basic: false },
                { _id: ClaimSecurityRight.ManageOutgoingClaims, name: 'Manage Outgoing Claims', basic: false },
                // Lets the office approve a claim before submission past open tasks only, never past a pending line or an uncompleted stage (WBS-12226).
                { _id: ClaimSecurityRight.ApproveClaimsWithUnresolvedTasks, name: 'Approve claims with unresolved tasks', basic: false }
            ] as SecurityRight<ClaimSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }

}

